import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    gap: "16px",
    alignItems: "flex-start",
    direction: "ltr",
    width: "100%",
    minWidth: 0,
  },
  detailSection: {
    flex: "0 0 512px",
    width: "512px",
  },
  tableSection: {
    flex: "1088 1 0",
    minWidth: 0,
  },
}));
